




































































































































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';

import Toast from '@/mixins/toast';
import Card from '@/components/UI/Card.vue';

import MmHintedButton from '../../components/MmHintedButton.vue';
import MmStates from '../../components/MmStates.vue';
import TaskCard from '../tasks/TaskCard.vue';
import TaskResultsTable from '../tasks/TaskResultsTable.vue';
import AcceptMonitoringDialog from './AcceptMonitoringDialog.vue';
import BatchTasksTable from './BatchTasksTable.vue';
import MonitoringMeta from './MonitoringMeta.vue';
import MonitoringSummary from './MonitoringSummary.vue';
import PhotoExportsPanel from './PhotoExportsPanel.vue';
import ResultsFilters from './ResultsFilters.vue';

import { createCancelSource, MmRequestConfig, readMmError } from '../../api/mmHttp';
import { buildPageQuery, createSortingState, MM_QUERY_PARAM_NAMES } from '../../api/pagination';
import {
	acceptTaskResults,
	bulkReviewBatchResults,
	fetchMonitoringResultsByIds,
	MmBulkReviewAction,
} from '../../api/results';
import { fetchTasks } from '../../api/tasks';
import { formatDiagnostics, isCanceled, MmError } from '../../core/errors';
import { formatMonitoringSelectLabel, MM_EMPTY_DASH } from '../../core/format';
import { getSessionStore } from '../../core/session';
import { getBadgeSpec } from '../../core/statuses';
import { MmMonitoringResult, MmTask } from '../../types/domain';
import {
	MmPage,
	MmResultGroupsResponse,
	MmResultListFilters,
	MmResultsSelectCheckBoxesData,
} from '../../types/dto';
import { MmOutcome, MmReviewStatus, MmTaskStatus, MmTaskType } from '../../types/enums';
import { MmTaskResultsContext } from '../tasks/taskCardExtensions';
import { MmMonitoringNavigationIntent, normalizeMonitoringNavigationIntent } from '../monitoringNavigation';
import {
	buildBatchScopeFilters,
	decorateResultsWithTaskInfo,
	findBatchByKey,
	groupTasksIntoBatches,
	MmMonitoringBatch,
	resolveBatchKeyForNavigation,
	resolvePositionsTotal,
} from './batch';
import {
	buildResultsRequestFilters,
	createEmptyResultsFilters,
	MmResultsScreenFilters,
} from './filters';

const KEY = 'priceMonitoring.mobileMonitoring.results.';

const SECTION_TASKS = 'results/batches';
const SECTION_COUNTS = 'results/counts';
const SECTION_ACCEPT = 'results/accept';

/** Потолок вместо страничного чтения: пачки восстанавливаются из заданий, свежих этого хватает */
const TASKS_PAGE_SIZE = 500;

/** Клиентский размер страницы пачки — живые `byIds` пагинацию не знают. */
const GROUP_PAGE_SIZE = 50;

type MmResultsView = 'summary' | 'card';

interface MmBatchOption {
	value: string;
	label: string;
}

interface MmAcceptRejection {
	taskId: string;
	message: string;
	serverCode: string | null;
}

@Component({
	components: {
		AcceptMonitoringDialog,
		BatchTasksTable,
		Card,
		MmHintedButton,
		MmStates,
		MonitoringMeta,
		MonitoringSummary,
		PhotoExportsPanel,
		ResultsFilters,
		TaskCard,
		TaskResultsTable,
	},
})
export default class ResultsSection extends Mixins(Toast) {
	@Prop({ default: null }) readonly tradingId!: number | null;

	/** Проп объявлен, хотя не используется: иначе он осел бы в $attrs и уехал атрибутом в DOM */
	@Prop({ default: '' }) readonly tradingName!: string;

	/** ant-design-vue 1.7.8 не размонтирует открытую вкладку, поэтому запросы идут только при isActive */
	@Prop({ default: false }) readonly isActive!: boolean;

	batches: MmMonitoringBatch[] = [];

	selectedBatchKey: string = '';

	isTasksLoading: boolean = false;

	hasLoadedTasks: boolean = false;

	tasksTotalOnServer: number = 0;

	loadError: MmError | null = null;

	filters: MmResultsScreenFilters = createEmptyResultsFilters();

	resultsTotal: number = 0;

	batchResultsTotal: number = 0;

	acceptedTotal: number = 0;

	pendingTotal: number = 0;

	resultCountByTaskId: { [taskId: string]: number } = {};

	isCountsLoading: boolean = false;

	/** Взводится после первой загрузки: повторный запрос не гасит показанную сводку */
	hasLoadedCounts: boolean = false;

	view: MmResultsView = 'summary';

	openTaskId: string | null = null;
	shouldRestoreBatchTableScroll: boolean = false;

	private pendingMonitoringNavigation: MmMonitoringNavigationIntent | null = null;

	private pendingScrollToBatchTable: boolean = false;

	private scrollToBatchTableAttempts: number = 0;

	private scrollToBatchTableRetryTimer: number | null = null;

	private scrollToBatchTableScrollTimer: number | null = null;

	private isSectionDestroyed: boolean = false;

	isAcceptDialogVisible: boolean = false;

	isAccepting: boolean = false;

	acceptDoneCount: number = 0;

	acceptTotalCount: number = 0;

	/** Только временные отказы — сеть, таймаут, 429, 5xx; постоянные уходят в rejectedTasks */
	failedTaskIds: string[] = [];

	rejectedTasks: MmAcceptRejection[] = [];

	countsLoadFailed = false;

	private needsReload: boolean = false;

	private tasksSource: any = null;

	private countsSource: any = null;

	private acceptSource: any = null;

	get session() {
		return getSessionStore();
	}

	created(): void {
		this.loadTasks();
	}

	beforeDestroy(): void {
		this.isSectionDestroyed = true;
		this.cancelTasksRequest();
		this.cancelCountsRequest();
		this.cancelAcceptRequest();
		this.clearBatchTableScrollTimers();
	}

	@Watch('session.readyTick')
	onSessionReady(): void {
		if (!this.isActive) {
			this.needsReload = true;

			return;
		}

		this.loadTasks();
	}

	@Watch('isActive')
	onActiveChanged(next: boolean): void {
		if (next === true && this.needsReload) {
			this.needsReload = false;
			this.loadTasks();
		}
	}

	get selectedBatch(): MmMonitoringBatch | null {
		return findBatchByKey(this.batches, this.selectedBatchKey);
	}

	get batchOptions(): MmBatchOption[] {
		const options: MmBatchOption[] = [];

		for (let i = 0; i < this.batches.length; i += 1) {
			options.push({
				value: this.batches[i].key,
				label: this.buildBatchLabel(this.batches[i]),
			});
		}

		return options;
	}

	/** Для a-select пустая строка — уже выбранное значение, поэтому вместо неё undefined */
	get selectValue(): string | undefined {
		return this.selectedBatchKey !== '' ? this.selectedBatchKey : undefined;
	}

	get isBatchListTruncated(): boolean {
		return this.hasLoadedTasks && this.tasksTotalOnServer > TASKS_PAGE_SIZE;
	}

	get batchListTruncatedHint(): string {
		return this.$t('priceMonitoring.mobileMonitoring.results.monitoringTruncatedHint', {
			shown: String(TASKS_PAGE_SIZE),
			total: String(this.tasksTotalOnServer),
		}) as string;
	}

	get representativeTask(): MmTask | null {
		const batch = this.selectedBatch;

		return batch !== null && batch.tasks.length > 0 ? batch.tasks[0] : null;
	}

	/** Пустая строка легальна: свойство таблицы обязательно, а пачки может не быть — запрос не уйдёт */
	get representativeTaskId(): string {
		const task = this.representativeTask;

		return task !== null ? String(task.id) : '';
	}

	get batchSize(): number | null {
		const batch = this.selectedBatch;

		return batch !== null ? batch.tasksTotal : null;
	}

	get batchTaskIds(): string[] {
		const batch = this.selectedBatch;

		return batch !== null ? batch.taskIds : [];
	}

	private buildBatchLabel(batch: MmMonitoringBatch): string {
		return formatMonitoringSelectLabel({
			createdAt: batch.createdAt,
			typeLabel: this.readTypeLabel(batch.type),
			storeFormatName: batch.storeFormatName,
			storeRegionName: batch.storeRegionName,
			storeClusterName: batch.storeClusterName,
			isApproximate: batch.isApproximate,
			approxLabel: this.$t(KEY + 'monitoringApprox') as string,
			fallback: batch.key,
		});
	}

	private readTypeLabel(type: MmTaskType | null): string {
		const spec = getBadgeSpec('taskType', type);

		return spec !== null ? (this.$t(spec.labelKey) as string) : '';
	}

	get screenState(): string {
		if (this.tradingId === null) {
			return 'networkNotSelected';
		}

		if (this.isTasksLoading && !this.hasLoadedTasks) {
			return 'loading';
		}

		if (this.loadError !== null) {
			return 'error';
		}

		if (this.batches.length === 0) {
			return 'empty';
		}

		return '';
	}

	get screenTitleOverride(): string {
		return this.screenState === 'empty' ? (this.$t(KEY + 'stateNoBatches') as string) : '';
	}

	get screenTextOverride(): string {
		return this.screenState === 'empty' ? (this.$t(KEY + 'stateNoBatchesHint') as string) : '';
	}

	get screenErrorText(): string {
		if (this.loadError === null) {
			return '';
		}

		return this.loadError.message ? String(this.loadError.message) : '';
	}

	get screenDiagnostics(): string {
		return this.loadError === null ? '' : formatDiagnostics(this.loadError.diagnostics);
	}

	get isScreenRetryable(): boolean {
		if (this.screenState === 'empty') {
			return true;
		}

		return this.loadError !== null ? this.loadError.retryable : false;
	}

	get isBusy(): boolean {
		return this.isTasksLoading || this.isAccepting;
	}

	get pickerDisabledReason(): string {
		if (this.isAccepting) {
			return this.acceptRunningReason;
		}

		if (this.isTasksLoading) {
			return this.$t('priceMonitoring.mobileMonitoring.states.loading') as string;
		}

		return '';
	}

	fieldLabelId(field: string): string {
		return 'sm-mobilemon-results-' + field + '-label-' + String((this as any)._uid);
	}

	/** Статусы намеренно не фильтруем: пачка — это все задания одного создания */
	loadTasks(): void {
		if (this.tradingId === null) {
			return;
		}

		if (!this.isActive) {
			this.needsReload = true;

			return;
		}

		this.cancelTasksRequest();

		const source = createCancelSource();

		this.tasksSource = source;
		this.isTasksLoading = !this.hasLoadedTasks;
		this.loadError = null;
		this.needsReload = false;

		const pageParams = buildPageQuery(
			{ current: 1, pageSize: TASKS_PAGE_SIZE, total: 0 },
			createSortingState('createdAt', 'desc'),
		);

		fetchTasks(this.tradingId, {}, pageParams, { cancelToken: source.token })
			.then((page) => {
				if (this.tasksSource !== source) {
					return;
				}

				this.batches = groupTasksIntoBatches(page.content);
				this.reapplyResultCountsToCurrentBatch();
				this.tasksTotalOnServer = typeof page.totalElements === 'number' ? page.totalElements : 0;
				this.hasLoadedTasks = true;
				this.syncSelectedBatch();
			})
			.catch((error) => {
				if (isCanceled(error) || this.tasksSource !== source) {
					return;
				}

				this.batches = [];
				this.tasksTotalOnServer = 0;
				this.loadError = readMmError(error, SECTION_TASKS);
				this.pendingMonitoringNavigation = null;
				this.pendingScrollToBatchTable = false;
				this.clearBatchTableScrollTimers();
			})
			.finally(() => {
				if (this.tasksSource !== source) {
					return;
				}

				this.tasksSource = null;
				this.isTasksLoading = false;
			});
	}

	private syncSelectedBatch(): void {
		if (this.pendingMonitoringNavigation !== null) {
			this.tryApplyPendingMonitoringNavigation();

			if (findBatchByKey(this.batches, this.selectedBatchKey) !== null) {
				return;
			}

			this.selectedBatchKey = '';

			return;
		}

		const current = findBatchByKey(this.batches, this.selectedBatchKey);

		if (current !== null) {
			this.loadReviewCounts();

			return;
		}

		this.selectedBatchKey = this.batches.length > 0 ? this.batches[0].key : '';
		this.filters = createEmptyResultsFilters();
		this.applyScopeChange();
	}

	handleBatchChange(key: string): void {
		const next = key ? String(key) : '';

		if (next === this.selectedBatchKey) {
			return;
		}

		this.selectedBatchKey = next;
		this.resultCountByTaskId = {};
		this.hasLoadedCounts = false;

		this.filters = Object.assign({}, this.filters, { taskIds: [] as string[] });

		this.closeCard();
		this.applyScopeChange();
	}

	applyMonitoringNavigation(intent: MmMonitoringNavigationIntent): void {
		const normalized = normalizeMonitoringNavigationIntent(intent);

		if (normalized === null) {
			return;
		}

		this.pendingMonitoringNavigation = normalized;
		this.pendingScrollToBatchTable = true;
		this.scrollToBatchTableAttempts = 0;
		this.clearBatchTableScrollTimers();

		if (this.view === 'card') {
			this.view = 'summary';
			this.openTaskId = null;
			this.shouldRestoreBatchTableScroll = false;
		}

		this.tryApplyPendingMonitoringNavigation();
	}

	handleGoToBatchFromCard(payload: MmMonitoringNavigationIntent): void {
		this.applyMonitoringNavigation(payload);
	}

	private failMonitoringNavigation(): void {
		this.pendingMonitoringNavigation = null;
		this.pendingScrollToBatchTable = false;
		this.scrollToBatchTableAttempts = 0;
		this.clearBatchTableScrollTimers();
		this.showError(this.$t(KEY + 'monitoringNavigationFailed') as string);
	}

	private tryApplyPendingMonitoringNavigation(): void {
		const intent = this.pendingMonitoringNavigation;

		if (intent === null || this.batches.length === 0) {
			return;
		}

		const key = resolveBatchKeyForNavigation(this.batches, intent.batchId, intent.taskId);
		const batch = key !== null ? findBatchByKey(this.batches, key) : null;

		if (batch === null) {
			this.failMonitoringNavigation();

			return;
		}

		this.pendingMonitoringNavigation = null;

		if (batch.key !== this.selectedBatchKey) {
			this.selectedBatchKey = batch.key;
			this.filters = Object.assign({}, this.filters, { taskIds: [] as string[] });
			this.applyScopeChange();
		} else if (this.filters.taskIds.length > 0) {
			this.filters = Object.assign({}, this.filters, { taskIds: [] as string[] });
			this.applyScopeChange();
		}

		this.scrollToBatchTasksTable();
	}

	private clearBatchTableScrollTimers(): void {
		if (this.scrollToBatchTableRetryTimer !== null) {
			window.clearTimeout(this.scrollToBatchTableRetryTimer);
			this.scrollToBatchTableRetryTimer = null;
		}

		if (this.scrollToBatchTableScrollTimer !== null) {
			window.clearTimeout(this.scrollToBatchTableScrollTimer);
			this.scrollToBatchTableScrollTimer = null;
		}
	}

	/** Запас при прокрутке: без него якорь уезжает под липкую шапку и клон заголовка таблицы ant */
	private alignBatchTasksTableInView(element: HTMLElement): void {
		const headerNode = element.querySelector('.ant-table-header');
		const theadNode = headerNode !== null ? headerNode : element.querySelector('.ant-table-thead');
		// 40 пикселей — запас на случай, если шапка колонок ещё не измерена
		let headerPx = 40;

		if (theadNode !== null) {
			const height = (theadNode as HTMLElement).getBoundingClientRect().height;

			if (height > 0) {
				headerPx = Math.ceil(height);
			}
		}

		element.style.setProperty('scroll-margin-top', String(headerPx + 19) + 'px');
		element.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}

	private scrollToBatchTasksTable(): void {
		if (!this.pendingScrollToBatchTable) {
			return;
		}

		this.$nextTick(() => {
			if (this.isSectionDestroyed) {
				return;
			}

			const table = this.$refs.batchTasksTable as any;
			const element = table && table.$el ? table.$el as HTMLElement : null;

			if (element === null || element.nodeType !== 1) {
				this.scrollToBatchTableAttempts += 1;

				if (this.scrollToBatchTableAttempts < 6) {
					this.clearBatchTableScrollTimers();
					this.scrollToBatchTableRetryTimer = window.setTimeout(() => {
						this.scrollToBatchTasksTable();
					}, 200);
				} else {
					this.pendingScrollToBatchTable = false;
					this.scrollToBatchTableAttempts = 0;
				}

				return;
			}

			this.pendingScrollToBatchTable = false;
			this.scrollToBatchTableAttempts = 0;
			this.clearBatchTableScrollTimers();

			this.scrollToBatchTableScrollTimer = window.setTimeout(() => {
				if (this.isSectionDestroyed) {
					return;
				}

				this.alignBatchTasksTableInView(element);
			}, 500);
		});
	}

	handleFiltersApply(next: MmResultsScreenFilters): void {
		if (this.isRefreshing) {
			return;
		}

		if (next !== null && next !== undefined) {
			this.filters = next;
		}

		this.applyScopeChange();
	}

	handleFiltersReset(): void {
		this.filters = createEmptyResultsFilters();
		this.applyScopeChange();
	}

	private applyScopeChange(): void {
		this.resultsTotal = 0;
		this.failedTaskIds = [];
		this.rejectedTasks = [];
		this.hasLoadedCounts = false;

		this.loadReviewCounts();

		this.$nextTick(() => {
			const table = this.$refs.table as any;

			if (!table) {
				return;
			}

			if (typeof table.clearSelection === 'function') {
				table.clearSelection();
			}

			if (typeof table.reload === 'function') {
				table.reload();
			}
		});
	}

	handleResultsTotal(total: number): void {
		this.resultsTotal = typeof total === 'number' ? total : 0;
	}

	/** Пустой список заданий бэкенд может прочесть как «ограничений нет», поэтому отдаём всю пачку */
	private resolveScopeTaskIds(): string[] {
		const scope = buildBatchScopeFilters(this.selectedBatch);
		const all = scope.taskIds ? scope.taskIds : [];
		const picked = this.filters.taskIds;

		if (picked.length === 0 || all.length === 0) {
			return all;
		}

		const index: { [taskId: string]: true } = {};

		for (let i = 0; i < all.length; i += 1) {
			index[all[i]] = true;
		}

		const narrowed: string[] = [];

		for (let i = 0; i < picked.length; i += 1) {
			if (index[picked[i]] === true) {
				narrowed.push(picked[i]);
			}
		}

		return narrowed.length > 0 ? narrowed : all;
	}

	private buildScopeAndScreenFilters(): Partial<MmResultListFilters> {
		const screen = buildResultsRequestFilters(this.filters);

		return Object.assign({}, screen, { taskIds: this.resolveScopeTaskIds() });
	}

	get resultsContext(): MmTaskResultsContext {
		const batch = this.selectedBatch;

		return {
			scope: 'batch',
			taskId: null,
			batchId: batch !== null ? batch.batchId : null,
			/** Ключ хранения — batch.key, а не batchId: batchId приходит не всегда, ключи пачек слиплись бы */
			scopeKey: batch !== null ? batch.key : null,
			planTaskIds: batch !== null ? batch.taskIds.slice() : null,
			scopeTasks: batch !== null ? batch.tasks.slice() : null,
			titleKey: KEY + 'batchTableTitle',
			loadGroups: (config?: MmRequestConfig) => this.loadBatchGroups(config),
			loadResults: (
				filters: Partial<MmResultListFilters> & { classificationId?: string | null },
				pageParams: { [key: string]: any },
				config?: MmRequestConfig,
			) => this.loadBatchResults(filters, pageParams, config),
			scopeFilters: this.buildScopeAndScreenFilters(),
			/**
			 * Полный путь ключа локали с причиной блокировки; null — область приёмку не блокирует
			 * Ключ обязан быть без подстановок: таблица зовёт $t(key) без параметров
			 */
			scopeBlockedReasonKey: batch !== null && batch.incompleteTaskIds.length > 0
				? KEY + 'scopeBlockedDelivery'
				: null,
			allowBulkReview: true,
			submitReview: (
				action: MmBulkReviewAction,
				filters: { [key: string]: any },
				selectCheckBoxesData: MmResultsSelectCheckBoxesData,
				comment: string,
				config?: MmRequestConfig,
			) => this.submitBatchReview(action, filters, selectCheckBoxesData, comment, config),
			onReviewComplete: () => this.handleReviewComplete(),
		};
	}

	/** Агрегатов по пачке в контракте нет: возвращаем пустой список, знаменатель берём серверный */
	private loadBatchGroups(config?: MmRequestConfig): Promise<MmResultGroupsResponse> {
		const tradingId = this.tradingId;
		const batch = this.selectedBatch;

		if (tradingId === null || batch === null) {
			return Promise.resolve({ items: [], monitoringLevel: null, resultsTotal: 0 });
		}

		const request: MmRequestConfig = {};

		if (config && config.cancelToken) {
			request.cancelToken = config.cancelToken;
		}

		return fetchMonitoringResultsByIds(null, batch.taskIds, request).then((rows) => {
			const quickFilters = config && config.params ? config.params : {};
			const merged = Object.assign({}, quickFilters, this.buildScopeAndScreenFilters());
			const decorated = decorateResultsWithTaskInfo(rows, batch);
			const filtered = this.applyBatchLiveFilters(decorated, merged);
			let unspecified = 0;

			for (let i = 0; i < filtered.length; i += 1) {
				if (filtered[i].outcome === MmOutcome.UNSPECIFIED) {
					unspecified += 1;
				}
			}

			return {
				items: [],
				monitoringLevel: null,
				resultsTotal: filtered.length,
				resultsUnspecifiedTotal: unspecified,
			};
		});
	}

	/** Фильтры экрана перекрывают taskIds таблицы; classificationId сохраняем, totalElements не трогаем */
	private loadBatchResults(
		filters: Partial<MmResultListFilters> & { classificationId?: string | null },
		pageParams: { [key: string]: any },
		config?: MmRequestConfig,
	): Promise<MmPage<MmMonitoringResult>> {
		const tradingId = this.tradingId;
		const batch = this.selectedBatch;

		if (tradingId === null || batch === null) {
			return Promise.resolve({ content: [], totalElements: 0, totalKnown: true, hasMore: null });
		}

		const merged = Object.assign({}, filters, this.buildScopeAndScreenFilters());

		return fetchMonitoringResultsByIds(null, batch.taskIds, config).then((all) => {
			/** Склейка идёт до фильтра: код магазина, тип и логин лежат на задании, а не на позиции */
			const decorated = decorateResultsWithTaskInfo(all, batch);
			const filtered = this.applyBatchLiveFilters(decorated, merged);
			const total = filtered.length;
			const sorted = this.applyLiveSorting(filtered, pageParams);
			const current = this.readLiveCurrent(pageParams);
			const pageSize = this.readLivePageSize(pageParams);
			const start = (current - 1) * pageSize;

			return {
				content: sorted.slice(start, start + pageSize),
				totalElements: total,
				totalKnown: true,
				hasMore: null,
			};
		});
	}

	private applyBatchLiveFilters(rows: MmMonitoringResult[], filters: any): MmMonitoringResult[] {
		const f: any = filters ? filters : {};
		let result = rows.slice();

		if (f.onlyAnalogs === true) {
			result = result.filter((r) => r.isAnalog === true);
		}

		if (f.onlyUnspecifiedOutcome === true) {
			result = result.filter((r) => r.outcome === MmOutcome.UNSPECIFIED);
		}

		if (f.onlyLatest === true) {
			result = this.keepLatestCaptures(result);
		}

		const taskIds = this.takeStringList(f.taskIds);

		if (taskIds !== null) {
			result = result.filter((r) => taskIds.indexOf(String(r.taskId)) >= 0);
		}

		const competitorCodes = this.takeStringList(f.competitorCodes);

		if (competitorCodes !== null) {
			result = result.filter((r) => {
				const code = r.competitorCode ? String(r.competitorCode) : '';

				return competitorCodes.indexOf(code) >= 0;
			});
		}

		const auditorLogins = this.takeStringList(f.auditorLogins);

		if (auditorLogins !== null) {
			result = result.filter((r) => {
				const login = r.auditorLogin ? String(r.auditorLogin) : '';

				return auditorLogins.indexOf(login) >= 0;
			});
		}

		const types = this.takeStringList(f.types);

		if (types !== null) {
			result = result.filter((r) => {
				const type = r.taskType ? String(r.taskType) : '';

				return types.indexOf(type) >= 0;
			});
		}

		const reviewStatuses = this.takeStringList(f.reviewStatuses);

		if (reviewStatuses !== null) {
			result = result.filter((r) => reviewStatuses.indexOf(String(r.reviewStatus)) >= 0);
		}

		const outcomes = this.takeStringList(f.outcomes);

		if (outcomes !== null) {
			result = result.filter((r) => outcomes.indexOf(String(r.outcome)) >= 0);
		}

		const capturedFrom = this.takeText(f.capturedFrom);
		const capturedTo = this.takeText(f.capturedTo);

		if (capturedFrom !== null || capturedTo !== null) {
			result = result.filter((r) => this.liveInDateRange(r, capturedFrom, capturedTo));
		}

		const query = this.takeText(f.q);

		if (query !== null) {
			const needle = query.toLowerCase();

			result = result.filter((r) => this.liveMatchesSearch(r, needle));
		}

		return result;
	}

	private liveInDateRange(row: MmMonitoringResult, from: string | null, to: string | null): boolean {
		const captured = row.capturedAt ? String(row.capturedAt) : '';

		if (captured === '') {
			return false;
		}

		if (from !== null && captured < from) {
			return false;
		}

		if (to !== null && captured > to) {
			return false;
		}

		return true;
	}

	private liveMatchesSearch(row: MmMonitoringResult, needle: string): boolean {
		const fields: string[] = [
			row.competitorProductName ? String(row.competitorProductName) : '',
			row.competitorStoreName ? String(row.competitorStoreName) : '',
			row.competitorCode ? String(row.competitorCode) : '',
			this.readRawField(row, 'barCode'),
		];

		for (let i = 0; i < fields.length; i += 1) {
			if (fields[i].toLowerCase().indexOf(needle) >= 0) {
				return true;
			}
		}

		return false;
	}

	private keepLatestCaptures(rows: MmMonitoringResult[]): MmMonitoringResult[] {
		const best: { [key: string]: MmMonitoringResult } = {};

		for (let i = 0; i < rows.length; i += 1) {
			const row = rows[i];
			const key = this.liveCaptureKey(row);
			const existing = best[key];

			if (existing === undefined || this.liveCaptureTime(row) >= this.liveCaptureTime(existing)) {
				best[key] = row;
			}
		}

		const out: MmMonitoringResult[] = [];

		for (const k in best) {
			if (Object.prototype.hasOwnProperty.call(best, k)) {
				out.push(best[k]);
			}
		}

		return out;
	}

	private liveCaptureKey(row: MmMonitoringResult): string {
		const code = this.readRawField(row, 'barCode');
		const identity = code !== '' ? code : String(row.id);

		return String(row.taskId) + '|' + identity;
	}

	private liveCaptureTime(row: MmMonitoringResult): string {
		return row.capturedAt ? String(row.capturedAt) : '';
	}

	private applyLiveSorting(rows: MmMonitoringResult[], pageParams: { [key: string]: any }): MmMonitoringResult[] {
		const rawBy = pageParams ? pageParams[MM_QUERY_PARAM_NAMES.sortBy] : null;
		const rawDir = pageParams ? pageParams[MM_QUERY_PARAM_NAMES.sortDirection] : null;
		const sortBy = rawBy === null || rawBy === undefined ? '' : String(rawBy);
		const order = rawDir === null || rawDir === undefined ? '' : String(rawDir);

		if (sortBy === '' || order === '') {
			return rows;
		}

		const dir = order === 'desc' ? -1 : 1;
		const copy = rows.slice();

		copy.sort((a, b) => {
			const c = this.liveCompare(a, b, sortBy);

			return c === 0 ? 0 : c * dir;
		});

		return copy;
	}

	private liveCompare(a: MmMonitoringResult, b: MmMonitoringResult, field: string): number {
		if (field === 'price') {
			const va = a.price !== null && a.price !== undefined ? a.price : Number.POSITIVE_INFINITY;
			const vb = b.price !== null && b.price !== undefined ? b.price : Number.POSITIVE_INFINITY;

			return va === vb ? 0 : va < vb ? -1 : 1;
		}

		if (field === 'capturedAt') {
			const sa = a.capturedAt ? String(a.capturedAt) : '';
			const sb = b.capturedAt ? String(b.capturedAt) : '';

			return sa === sb ? 0 : sa < sb ? -1 : 1;
		}

		if (field === 'productName') {
			const na = a.competitorProductName ? String(a.competitorProductName) : this.readRawField(a, 'barCode');
			const nb = b.competitorProductName ? String(b.competitorProductName) : this.readRawField(b, 'barCode');

			return na === nb ? 0 : na < nb ? -1 : 1;
		}

		return 0;
	}

	/** Номер страницы (1-индексный) из параметров запроса (`page = current - 1`). */
	private readLiveCurrent(pageParams: { [key: string]: any }): number {
		const raw = pageParams ? pageParams[MM_QUERY_PARAM_NAMES.page] : null;
		const pageZero = typeof raw === 'number' ? raw : Number(raw);

		return isFinite(pageZero) && pageZero >= 0 ? pageZero + 1 : 1;
	}

	private readLivePageSize(pageParams: { [key: string]: any }): number {
		const raw = pageParams ? pageParams[MM_QUERY_PARAM_NAMES.size] : null;
		const size = typeof raw === 'number' ? raw : Number(raw);

		return isFinite(size) && size > 0 ? size : GROUP_PAGE_SIZE;
	}

	private readRawField(result: MmMonitoringResult | null, field: string): string {
		const source: any = result;

		if (!source || source[field] === null || source[field] === undefined) {
			return '';
		}

		return String(source[field]).trim();
	}

	private takeStringList(source: string[] | null | undefined): string[] | null {
		if (source === null || source === undefined || source.length === 0) {
			return null;
		}

		const result: string[] = [];

		for (let i = 0; i < source.length; i += 1) {
			const value = source[i];

			if (value !== null && value !== undefined && String(value) !== '') {
				result.push(String(value));
			}
		}

		return result.length > 0 ? result : null;
	}

	private takeText(source: string | null | undefined): string | null {
		if (source === null || source === undefined) {
			return null;
		}

		const text = String(source).trim();

		return text !== '' ? text : null;
	}

	private submitBatchReview(
		action: MmBulkReviewAction,
		filters: { [key: string]: any },
		selectCheckBoxesData: MmResultsSelectCheckBoxesData,
		comment: string,
		config?: MmRequestConfig,
	): Promise<{ data: { affected: number } }> {
		const taskIds = filters && filters.taskIds ? filters.taskIds : [];

		if (taskIds.length === 0) {
			this.showError(this.$t(KEY + 'acceptBlockedNoBatch') as string);

			/** Помечаем отказ как отмену: запрос не уходил, причина уже показана, второе сообщение лишнее */
			const aborted: any = new Error('mm_batch_scope_empty');

			aborted.__CANCEL__ = true;

			return Promise.reject(aborted);
		}

		return bulkReviewBatchResults(action, filters, selectCheckBoxesData, comment, config);
	}

	/** Числа приёмки считаем по всей пачке и без экранных фильтров: приёмка идёт по всем заданиям */
	private loadReviewCounts(): void {
		this.cancelCountsRequest();

		const tradingId = this.tradingId;
		const batch = this.selectedBatch;

		if (tradingId === null || batch === null) {
			this.batchResultsTotal = 0;
			this.acceptedTotal = 0;
			this.pendingTotal = 0;
			this.resultCountByTaskId = {};
			this.hasLoadedCounts = false;

			return;
		}

		const source = createCancelSource();

		this.countsSource = source;
		this.isCountsLoading = !this.hasLoadedCounts;

		fetchMonitoringResultsByIds(null, batch.taskIds, { cancelToken: source.token })
			.then((rows) => {
				if (this.countsSource !== source) {
					return;
				}

				let accepted = 0;
				let pending = 0;

				for (let i = 0; i < rows.length; i += 1) {
					const status = rows[i].reviewStatus;

					if (status === MmReviewStatus.ACCEPTED || status === MmReviewStatus.PRICE_CORRECTED) {
						accepted += 1;
					} else if (status === MmReviewStatus.PENDING) {
						pending += 1;
					}
				}

				this.acceptedTotal = accepted;
				this.pendingTotal = pending;
				this.batchResultsTotal = rows.length;
				this.countsLoadFailed = false;
				this.hasLoadedCounts = true;
				this.syncResultCountsFromRows(rows);
			})
			.catch((error) => {
				if (isCanceled(error) || this.countsSource !== source) {
					return;
				}

				this.batchResultsTotal = 0;
				this.acceptedTotal = 0;
				this.pendingTotal = 0;
				this.countsLoadFailed = true;
			})
			.finally(() => {
				if (this.countsSource !== source) {
					return;
				}

				this.countsSource = null;
				this.isCountsLoading = false;
			});
	}

	handleReviewComplete(): void {
		this.loadReviewCounts();
	}

	private syncResultCountsFromRows(rows: MmMonitoringResult[]): void {
		const counts: { [taskId: string]: number } = {};

		for (let i = 0; i < rows.length; i += 1) {
			const taskId = rows[i].taskId;

			if (taskId !== null && taskId !== undefined && String(taskId) !== '') {
				const key = String(taskId);
				const prev = counts[key];

				counts[key] = typeof prev === 'number' ? prev + 1 : 1;
			}
		}

		this.resultCountByTaskId = counts;
		this.patchCurrentBatchPositions(counts);
	}

	private reapplyResultCountsToCurrentBatch(): void {
		const keys = Object.keys(this.resultCountByTaskId);

		if (keys.length === 0) {
			return;
		}

		this.patchCurrentBatchPositions(this.resultCountByTaskId);
	}

	private patchCurrentBatchPositions(counts: { [taskId: string]: number }): void {
		const batch = findBatchByKey(this.batches, this.selectedBatchKey);

		if (batch === null) {
			return;
		}

		let changed = false;
		const patchedTasks: MmTask[] = [];

		for (let i = 0; i < batch.tasks.length; i += 1) {
			const task = batch.tasks[i];
			const loadedCount = counts[task.id];
			const nextTotal = resolvePositionsTotal(task, loadedCount);

			if (nextTotal !== task.positionsTotal) {
				changed = true;
				patchedTasks.push(Object.assign({}, task, { positionsTotal: nextTotal }));
			} else {
				patchedTasks.push(task);
			}
		}

		if (!changed) {
			return;
		}

		const patchedBatch = Object.assign({}, batch, { tasks: patchedTasks });
		const nextBatches: MmMonitoringBatch[] = [];

		for (let i = 0; i < this.batches.length; i += 1) {
			nextBatches.push(this.batches[i].key === batch.key ? patchedBatch : this.batches[i]);
		}

		this.batches = nextBatches;
	}

	get acceptDisabledReason(): string {
		if (this.isAccepting) {
			return this.acceptRunningReason;
		}

		const batch = this.selectedBatch;

		if (batch === null || batch.taskIds.length === 0) {
			return this.$t(KEY + 'acceptBlockedNoBatch') as string;
		}

		if (batch.incompleteTaskIds.length > 0) {
			return this.$t(KEY + 'acceptBlockedDelivery', {
				delivered: this.formatDeliveryCount(batch.incompleteTaskIds, false),
				expected: this.formatDeliveryCount(batch.incompleteTaskIds, true),
			}) as string;
		}

		if (this.selectAcceptableTaskIds(batch.taskIds, batch).length === 0) {
			return this.$t(KEY + 'acceptBlockedNothingToSend') as string;
		}

		if (this.countsLoadFailed) {
			return this.$t(KEY + 'acceptBlockedCountsUnknown') as string;
		}

		if (this.acceptedTotal === 0) {
			return this.$t(KEY + 'acceptBlockedNothing') as string;
		}

		return '';
	}

	get isAcceptDisabled(): boolean {
		return this.acceptDisabledReason !== '';
	}

	get acceptRunningReason(): string {
		return this.$t(KEY + 'acceptRunning') as string;
	}

	get acceptProgressText(): string {
		return this.acceptRunningReason + ' ' + String(this.acceptDoneCount) + ' / ' + String(this.acceptTotalCount);
	}

	get acceptRejectedNote(): string {
		if (this.rejectedTasks.length === 0) {
			return '';
		}

		const reasons = this.collectRejectionReasons();

		return this.$t(KEY + 'acceptRejected', {
			count: this.rejectedTasks.length,
			reason: reasons.length > 0 ? reasons.join('; ') : (this.$t(KEY + 'acceptRejectedNoReason') as string),
		}) as string;
	}

	openAcceptDialog(): void {
		if (this.isAcceptDisabled) {
			return;
		}

		this.isAcceptDialogVisible = true;
	}

	closeAcceptDialog(): void {
		if (this.isAccepting) {
			return;
		}

		this.isAcceptDialogVisible = false;
	}

	handleAcceptConfirm(): void {
		this.isAcceptDialogVisible = false;

		/** Сброс отказов стоит здесь, а не в последовательности: повтор обязан их сохранить */
		this.rejectedTasks = [];

		this.runAcceptSequence(this.batchTaskIds.slice());
	}

	/** Повторяем только временные отказы: окончательно отклонённые упрутся в тот же отказ */
	retryAccept(): void {
		if (this.isAccepting) {
			return;
		}

		this.runAcceptSequence(this.failedTaskIds.slice());
	}

	private runAcceptSequence(taskIds: string[]): void {
		if (taskIds.length === 0 || this.isAccepting) {
			return;
		}

		const acceptable = this.selectAcceptableTaskIds(taskIds, this.selectedBatch);

		if (acceptable.length === 0) {
			this.showError(this.$t(KEY + 'acceptBlockedNothingToSend') as string);

			return;
		}

		this.cancelAcceptRequest();

		const source = createCancelSource();

		this.acceptSource = source;
		this.isAccepting = true;
		this.acceptDoneCount = 0;
		this.acceptTotalCount = acceptable.length;

		/** Обнуляем только повторимые отказы: окончательные должны пережить повтор, иначе будет ложный успех */
		this.failedTaskIds = [];

		const succeeded: string[] = [];
		const queued: string[] = [];

		const step = (index: number): Promise<void> => {
			if (index >= acceptable.length || this.acceptSource !== source) {
				return Promise.resolve();
			}

			const taskId = acceptable[index];

			return acceptTaskResults(taskId, { cancelToken: source.token })
				.then((response) => {
					if (this.acceptSource !== source) {
						return;
					}

					succeeded.push(taskId);

					const status = response && response.status ? Number(response.status) : 0;
					const data = response && response.data ? response.data : null;
					const operationId = data && data.operationId ? String(data.operationId) : '';

					if (status === 202 || operationId !== '') {
						queued.push(operationId);
					}
				})
				.catch((error) => {
					if (isCanceled(error) || this.acceptSource !== source) {
						return;
					}

					const mmError = readMmError(error, SECTION_ACCEPT);

					if (mmError.retryable) {
						this.failedTaskIds.push(taskId);

						return;
					}

					this.rejectedTasks.push({
						taskId: taskId,
						message: mmError.message,
						serverCode: mmError.serverCode,
					});
				})
				.then(() => {
					if (this.acceptSource !== source) {
						return;
					}

					this.acceptDoneCount += 1;

					return step(index + 1);
				});
		};

		step(0)
			.then(() => {
				if (this.acceptSource !== source) {
					return;
				}

				this.reportAcceptResult(succeeded, queued);
			})
			.finally(() => {
				if (this.acceptSource !== source) {
					return;
				}

				this.acceptSource = null;
				this.isAccepting = false;
			});
	}

	/** Отсекаем до отправки статусы, на которые сервер ответит 409: «назначено» и «отклонено» */
	private selectAcceptableTaskIds(taskIds: string[], batch: MmMonitoringBatch | null): string[] {
		if (taskIds.length === 0 || batch === null || batch.tasks.length === 0) {
			return [];
		}

		const statusByTaskId: { [key: string]: string } = {};

		for (let i = 0; i < batch.tasks.length; i += 1) {
			statusByTaskId[batch.tasks[i].id] = batch.tasks[i].status;
		}

		const acceptable: string[] = [];

		for (let i = 0; i < taskIds.length; i += 1) {
			const status = statusByTaskId[taskIds[i]];

			if (status === MmTaskStatus.COMPLETED || status === MmTaskStatus.ACCEPTED) {
				acceptable.push(taskIds[i]);
			}
		}

		return acceptable;
	}

	private sentenceGap(previous: string): string {
		const text = String(previous || '').trim();

		if (text === '') {
			return '';
		}

		return /[.!?…]$/.test(text) ? ' ' : '. ';
	}

	private collectRejectionReasons(): string[] {
		const seen: { [key: string]: boolean } = {};
		const reasons: string[] = [];

		for (let i = 0; i < this.rejectedTasks.length; i += 1) {
			const text = String(this.rejectedTasks[i].message || '').trim();

			if (text !== '' && seen[text] !== true) {
				seen[text] = true;
				reasons.push(text);
			}
		}

		return reasons;
	}

	private reportAcceptResult(succeeded: string[], queued: string[]): void {
		const rejectedCount = this.rejectedTasks.length;
		const retryableCount = this.failedTaskIds.length;
		const failedCount = rejectedCount + retryableCount;

		if (failedCount === 0) {
			let message = this.$t(KEY + 'acceptSuccess', {
				count: this.acceptedTotal,
			}) as string;

			if (queued.length > 0) {
				message = message + this.sentenceGap(message) + (this.$t(KEY + 'acceptQueued') as string);

				const operationId = this.readFirstOperationId(queued);

				if (operationId !== '') {
					message = message + this.sentenceGap(message)
						+ (this.$t(KEY + 'acceptOperationId', { id: operationId }) as string);
				}
			}

			this.showInfo(message);
			this.refreshAfterAccept();

			return;
		}

		const reasons = this.collectRejectionReasons();
		let tail = '';

		if (rejectedCount > 0) {
			tail = this.sentenceGap(tail) + (this.$t(KEY + 'acceptRejected', {
				count: rejectedCount,
				reason: reasons.length > 0 ? reasons.join('; ') : (this.$t(KEY + 'acceptRejectedNoReason') as string),
			}) as string);
		}

		if (retryableCount > 0) {
			tail = tail + this.sentenceGap(tail) + (this.$t(KEY + 'acceptRetryable', { count: retryableCount }) as string);
		}

		if (succeeded.length === 0) {
			const head = this.$t(KEY + 'acceptError') as string;

			this.showError(head + this.sentenceGap(head) + tail.replace(/^[.\s]+/, ''));
			this.refreshAfterAccept();

			return;
		}

		const partialHead = this.$t(KEY + 'acceptPartial', {
			count: MM_EMPTY_DASH,
			total: this.acceptedTotal,
		}) as string;

		this.showError(partialHead + this.sentenceGap(partialHead) + tail.replace(/^[.\s]+/, ''));
		this.refreshAfterAccept();
	}

	private readFirstOperationId(queued: string[]): string {
		for (let i = 0; i < queued.length; i += 1) {
			if (queued[i] !== '') {
				return queued[i];
			}
		}

		return '';
	}

	refreshAll(): void {
		this.loadTasks();
		this.loadReviewCounts();

		const table = this.$refs.table as any;

		if (table && typeof table.reload === 'function') {
			table.reload();
		}
	}

	get isRefreshing(): boolean {
		return this.tasksSource !== null || this.countsSource !== null
			|| this.isTasksLoading || this.isCountsLoading;
	}

	private refreshAfterAccept(): void {
		this.refreshAll();
	}

	/** Полей доставки может не быть: тогда прочерк, а не ноль — «0 из 0» было бы выдуманным утверждением */
	private formatDeliveryCount(taskIds: string[], expected: boolean): string {
		const sum = this.sumDeliveryCounter(taskIds, expected);

		return sum === null ? MM_EMPTY_DASH : String(sum);
	}

	/** null — ни одно задание счётчик не отдало; это не то же самое, что ноль */
	private sumDeliveryCounter(taskIds: string[], expected: boolean): number | null {
		const batch = this.selectedBatch;

		if (batch === null || taskIds.length === 0) {
			return null;
		}

		const wanted: { [taskId: string]: true } = {};

		for (let i = 0; i < taskIds.length; i += 1) {
			wanted[taskIds[i]] = true;
		}

		let sum = 0;
		let hasValue = false;

		for (let i = 0; i < batch.tasks.length; i += 1) {
			const task = batch.tasks[i];

			if (wanted[task.id] !== true) {
				continue;
			}

			const value = expected ? task.positionsExpected : task.positionsDelivered;

			if (typeof value === 'number' && !isNaN(value)) {
				sum += value;
				hasValue = true;
			}
		}

		return hasValue ? sum : null;
	}

	handleOpenTask(taskId: string): void {
		if (!taskId) {
			return;
		}

		this.shouldRestoreBatchTableScroll = true;
		this.openTaskId = String(taskId);
		this.view = 'card';
	}

	closeCard(): void {
		const restoreScroll = this.shouldRestoreBatchTableScroll;

		this.view = 'summary';
		this.openTaskId = null;
		this.shouldRestoreBatchTableScroll = false;

		if (!restoreScroll) {
			return;
		}

		this.pendingScrollToBatchTable = true;
		this.scrollToBatchTableAttempts = 0;
		this.scrollToBatchTasksTable();
	}

	private get openTaskIndex(): number {
		return this.openTaskId === null ? -1 : this.batchTaskIds.indexOf(this.openTaskId);
	}

	get prevTaskId(): string | null {
		const index = this.openTaskIndex;

		return index > 0 ? this.batchTaskIds[index - 1] : null;
	}

	get nextTaskId(): string | null {
		const index = this.openTaskIndex;

		return index >= 0 && index < this.batchTaskIds.length - 1 ? this.batchTaskIds[index + 1] : null;
	}

	private cancelTasksRequest(): void {
		if (this.tasksSource !== null) {
			this.tasksSource.cancel();
			this.tasksSource = null;
		}
	}

	private cancelCountsRequest(): void {
		if (this.countsSource !== null) {
			this.countsSource.cancel();
			this.countsSource = null;
		}
	}

	private cancelAcceptRequest(): void {
		if (this.acceptSource !== null) {
			this.acceptSource.cancel();
			this.acceptSource = null;
			this.isAccepting = false;
		}
	}
}
